var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6365 20.0002C21.4969 20.0002 21.3572 20.0533 21.2509 20.16L20.16 21.2509C19.9467 21.4641 19.9467 21.8094 20.16 22.0222L24.1379 26.0001L20.16 29.9781C19.9467 30.1914 19.9467 30.5367 20.16 30.7494L21.2509 31.8403C21.4641 32.0536 21.8094 32.0536 22.0222 31.8403L26.0001 27.8623L29.9781 31.8403C30.1908 32.0536 30.5367 32.0536 30.7494 31.8403L31.8403 30.7494C32.0536 30.5361 32.0536 30.1908 31.8403 29.9781L27.8623 26.0001L31.8403 22.0222C32.0536 21.8094 32.0536 21.4636 31.8403 21.2509L30.7494 20.16C30.5361 19.9467 30.1908 19.9467 29.9781 20.16L26.0001 24.1379L22.0222 20.16C21.9155 20.0533 21.7761 20.0002 21.6365 20.0002Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51.0002,
    height: 51.0002,
    rx: 25.5001,
    stroke: "#E3E3E3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.97fd7d8677970cef84ad10da766c01ae.svg";
export { ForwardRef as ReactComponent };